import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLoader } = FiIcons;

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
      <div className="w-64 h-64 relative">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover rounded-lg"
        >
          <source src="/vdo/thinking.mp4" type="video/mp4" />
          <img
            src="/images/thinking.png"
            alt="loading"
            className="w-full h-full object-cover rounded-lg"
          />
        </video>
      </div>
    </div>
  );
};

export default LoadingSpinner;
